document.addEventListener("DOMContentLoaded", function () {
    // Social icons hover
    document.querySelectorAll('.post__author-socials-icon img').forEach(img => {
        img.addEventListener('mouseenter', () => { img.src = img.dataset.hover; });
        img.addEventListener('mouseleave', () => { img.src = img.dataset.default; });
    });

    if (window.innerWidth > 960) return;

    const sidebarWrap = document.querySelector('.post__sidebar-wrap');
    const sidebar = document.querySelector('.post__sidebar.js-sidebar');
    const ratingEl = document.querySelector('.post__rating');
    const tocEl = document.querySelector('.post__toc');
    const authorEl = document.querySelector('.post__author');

    if (!sidebarWrap || !sidebar) return;

    const panelMap = { rating: ratingEl, toc: tocEl, author: authorEl };

    // ── Inject tab bar ────────────────────────────────────────────────────────
    const tabBar = document.createElement('div');
    tabBar.className = 'post__mobile-tabbar';
    tabBar.innerHTML = `
        <button type="button" class="post__mobile-tab" data-panel="toc" aria-label="Зміст">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_5120_75693)">
                    <mask id="mask0_5120_75693" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <path d="M24 0H0V24H24V0Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_5120_75693)">
                        <path d="M22 16.7397V4.6697C22 3.4697 21.02 2.5797 19.83 2.6797H19.77C17.67 2.8597 14.48 3.9297 12.7 5.0497L12.53 5.1597C12.24 5.3397 11.76 5.3397 11.47 5.1597L11.22 5.0097C9.44 3.8997 6.26 2.8397 4.16 2.6697C2.97 2.5697 2 3.4697 2 4.6597V16.7397C2 17.6997 2.78 18.5997 3.74 18.7197L4.03 18.7597C6.2 19.0497 9.55 20.1497 11.47 21.1997L11.51 21.2197C11.78 21.3697 12.21 21.3697 12.47 21.2197C14.39 20.1597 17.75 19.0497 19.93 18.7597L20.26 18.7197C21.22 18.5997 22 17.6997 22 16.7397Z" stroke="#F48859" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 5.49023V20.4902" stroke="#F48859" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.75 8.49023H5.5" stroke="#F48859" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.5 11.4902H5.5" stroke="#F48859" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_5120_75693">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
            <span>Зміст</span>
        </button>
        <button type="button" class="post__mobile-tab" data-panel="rating" aria-label="Оцінити">
            <svg class="star-icon--outline" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_star_outline)">
                    <mask id="mask0_star_outline" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <path d="M24 0H0V24H24V0Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_star_outline)">
                        <path d="M17.6601 22.6703C17.1301 22.6703 16.4501 22.5003 15.6001 22.0003L12.6101 20.2303C12.3001 20.0503 11.7001 20.0503 11.4001 20.2303L8.40012 22.0003C6.63012 23.0503 5.59012 22.6303 5.12012 22.2903C4.66012 21.9503 3.94012 21.0803 4.41012 19.0803L5.12012 16.0103C5.20012 15.6903 5.04012 15.1403 4.80012 14.9003L2.32012 12.4203C1.08012 11.1803 1.18012 10.1203 1.35012 9.60031C1.52012 9.08031 2.06012 8.16031 3.78012 7.87031L6.97012 7.34031C7.27012 7.29031 7.70012 6.97031 7.83012 6.70031L9.60012 3.17031C10.4001 1.56031 11.4501 1.32031 12.0001 1.32031C12.5501 1.32031 13.6001 1.56031 14.4001 3.17031L16.1601 6.69031C16.3001 6.96031 16.7301 7.28031 17.0301 7.33031L20.2201 7.86031C21.9501 8.15031 22.4901 9.07031 22.6501 9.59031C22.8101 10.1103 22.9101 11.1703 21.6801 12.4103L19.2001 14.9003C18.9601 15.1403 18.8101 15.6803 18.8801 16.0103L19.5901 19.0803C20.0501 21.0803 19.3401 21.9503 18.8801 22.2903C18.6301 22.4703 18.2301 22.6703 17.6601 22.6703ZM12.0001 18.5903C12.4901 18.5903 12.9801 18.7103 13.3701 18.9403L16.3601 20.7103C17.2301 21.2303 17.7801 21.2303 17.9901 21.0803C18.2001 20.9303 18.3501 20.4003 18.1301 19.4203L17.4201 16.3503C17.2301 15.5203 17.5401 14.4503 18.1401 13.8403L20.6201 11.3603C21.1101 10.8703 21.3301 10.3903 21.2301 10.0603C21.1201 9.73031 20.6601 9.46031 19.9801 9.35031L16.7901 8.82031C16.0201 8.69031 15.1801 8.07031 14.8301 7.37031L13.0701 3.85031C12.7501 3.21031 12.3501 2.83031 12.0001 2.83031C11.6501 2.83031 11.2501 3.21031 10.9401 3.85031L9.17012 7.37031C8.82012 8.07031 7.98012 8.69031 7.21012 8.82031L4.03012 9.35031C3.35012 9.46031 2.89012 9.73031 2.78012 10.0603C2.67012 10.3903 2.90012 10.8803 3.39012 11.3603L5.87012 13.8403C6.47012 14.4403 6.78012 15.5203 6.59012 16.3503L5.88012 19.4203C5.65012 20.4103 5.81012 20.9303 6.02012 21.0803C6.23012 21.2303 6.77012 21.2203 7.65012 20.7103L10.6401 18.9403C11.0201 18.7103 11.5101 18.5903 12.0001 18.5903Z" fill="#F48859"/>
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_star_outline">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
            <svg class="star-icon--filled" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_star_filled)">
                    <mask id="mask0_star_filled" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <path d="M24 0H0V24H24V0Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_star_filled)">
                        <path d="M17.6601 22.6703C17.1301 22.6703 16.4501 22.5003 15.6001 22.0003L12.6101 20.2303C12.3001 20.0503 11.7001 20.0503 11.4001 20.2303L8.40012 22.0003C6.63012 23.0503 5.59012 22.6303 5.12012 22.2903C4.66012 21.9503 3.94012 21.0803 4.41012 19.0803L5.12012 16.0103C5.20012 15.6903 5.04012 15.1403 4.80012 14.9003L2.32012 12.4203C1.08012 11.1803 1.18012 10.1203 1.35012 9.60031C1.52012 9.08031 2.06012 8.16031 3.78012 7.87031L6.97012 7.34031C7.27012 7.29031 7.70012 6.97031 7.83012 6.70031L9.60012 3.17031C10.4001 1.56031 11.4501 1.32031 12.0001 1.32031C12.5501 1.32031 13.6001 1.56031 14.4001 3.17031L16.1601 6.69031C16.3001 6.96031 16.7301 7.28031 17.0301 7.33031L20.2201 7.86031C21.9501 8.15031 22.4901 9.07031 22.6501 9.59031C22.8101 10.1103 22.9101 11.1703 21.6801 12.4103L19.2001 14.9003C18.9601 15.1403 18.8101 15.6803 18.8801 16.0103L19.5901 19.0803C20.0501 21.0803 19.3401 21.9503 18.8801 22.2903C18.6301 22.4703 18.2301 22.6703 17.6601 22.6703Z" fill="#F48859"/>
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_star_filled">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        </button>
        <button type="button" class="post__mobile-tab" data-panel="author" aria-label="Автор">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_5120_75713)">
                    <mask id="mask0_5120_75713" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <path d="M24 0H0V24H24V0Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_5120_75713)">
                        <path d="M15.0001 22.7498H9.00014C7.68014 22.7498 6.58015 22.6198 5.65015 22.3398C5.31015 22.2398 5.09015 21.9098 5.11015 21.5598C5.36015 18.5698 8.39015 16.2197 12.0001 16.2197C15.6101 16.2197 18.6301 18.5598 18.8901 21.5598C18.9201 21.9198 18.7001 22.2398 18.3501 22.3398C17.4201 22.6198 16.3201 22.7498 15.0001 22.7498ZM6.72015 21.0598C7.38015 21.1898 8.13015 21.2498 9.00014 21.2498H15.0001C15.8701 21.2498 16.6201 21.1898 17.2801 21.0598C16.7501 19.1398 14.5601 17.7197 12.0001 17.7197C9.44015 17.7197 7.25015 19.1398 6.72015 21.0598Z" fill="#F48859"/>
                        <path d="M15 2H9C4 2 2 4 2 9V15C2 18.78 3.14 20.85 5.86 21.62C6.08 19.02 8.75 16.97 12 16.97C15.25 16.97 17.92 19.02 18.14 21.62C20.86 20.85 22 18.78 22 15V9C22 4 20 2 15 2ZM12 14.17C10.02 14.17 8.42 12.56 8.42 10.58C8.42 8.60002 10.02 7 12 7C13.98 7 15.58 8.60002 15.58 10.58C15.58 12.56 13.98 14.17 12 14.17Z" stroke="#F48859" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.9999 14.92C9.60992 14.92 7.66992 12.97 7.66992 10.58C7.66992 8.19002 9.60992 6.25 11.9999 6.25C14.3899 6.25 16.3299 8.19002 16.3299 10.58C16.3299 12.97 14.3899 14.92 11.9999 14.92ZM11.9999 7.75C10.4399 7.75 9.16992 9.02002 9.16992 10.58C9.16992 12.15 10.4399 13.42 11.9999 13.42C13.5599 13.42 14.8299 12.15 14.8299 10.58C14.8299 9.02002 13.5599 7.75 11.9999 7.75Z" fill="#F48859"/>
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_5120_75713">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        </button>
    `;
    sidebar.appendChild(tabBar);

    // Hide TOC tab if no TOC exists
    if (!tocEl) {
        tabBar.querySelector('[data-panel="toc"]')?.remove();
    }

    if (!ratingEl) {
        tabBar.querySelector('[data-panel="rating"]')?.remove();
    }

    // ── Mark rating tab as voted ──────────────────────────────────────────────
    const ratingTab = tabBar.querySelector('[data-panel="rating"]');
    if (ratingTab && ratingEl) {
        // Already voted in a previous session
        const postId = (typeof ratingData !== 'undefined') ? ratingData.post_id : null;
        if (postId && localStorage.getItem(`rated_post_${postId}`)) {
            ratingTab.classList.add('is-voted');
        }

        // Vote happens NOW — observe star buttons getting disabled
        const ratingObserver = new MutationObserver(() => {
            if (ratingEl.querySelector('.post__rating-star[disabled]')) {
                ratingTab.classList.add('is-voted');
                ratingObserver.disconnect();
            }
        });
        ratingObserver.observe(ratingEl, {
            attributes: true,
            subtree: true,
            attributeFilter: ['disabled'],
        });
    }

    // ── Inject close buttons into each panel ──────────────────────────────────
    const closeSvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>`;

    Object.entries(panelMap).forEach(([key, el]) => {
        if (!el) return;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'post__panel-close';
        btn.setAttribute('aria-label', 'Закрити');
        btn.innerHTML = closeSvg;
        btn.addEventListener('click', () => closePanel(key));
        el.insertBefore(btn, el.firstChild);
    });

    // ── Open / close helpers ──────────────────────────────────────────────────
    function openPanel(key) {
        const el = panelMap[key];
        if (!el) return;
        // Close others first
        Object.keys(panelMap).forEach(k => {
            if (k !== key) closePanel(k);
        });
        el.classList.add('is-open');
        tabBar.querySelector(`[data-panel="${key}"]`)?.classList.add('is-active');
    }

    function closePanel(key) {
        panelMap[key]?.classList.remove('is-open');
        tabBar.querySelector(`[data-panel="${key}"]`)?.classList.remove('is-active');
    }

    // ── Tab clicks ────────────────────────────────────────────────────────────
    tabBar.querySelectorAll('.post__mobile-tab').forEach(tab => {
        tab.addEventListener('click', () => {
            const key = tab.dataset.panel;
            const isOpen = panelMap[key]?.classList.contains('is-open');
            if (isOpen) {
                closePanel(key);
            } else {
                openPanel(key);
            }
        });
    });
});
